import get from 'lodash/get';
import defaultFields from 'store/KnowledgeBase/fields';

const CREATE_DATE_DEFAULT_WIDTH = 170;
const CREATE_DATE_MIN_WIDTH = 120;
const CREATE_DATE_MAX_WIDTH = 260;

// eslint-disable-next-line import/prefer-default-export
export const selectFields = (state) => {
  const fields = get(state, 'preferences.kb_table', defaultFields);
  const newFields = {};
  Object.keys(defaultFields).forEach((key) => {
    const defaultField = defaultFields[key];
    const field = get(fields, key, defaultField);
    newFields[key] = {
      ...defaultField,
      ...field
    };

    if (key === 'create_date') {
      const minWidth = Math.max(
        CREATE_DATE_MIN_WIDTH,
        Math.min(newFields[key].minWidth || CREATE_DATE_MIN_WIDTH, CREATE_DATE_DEFAULT_WIDTH)
      );
      const maxWidth = Math.max(newFields[key].maxWidth || 0, CREATE_DATE_MAX_WIDTH);
      const defaultMin = Math.max(newFields[key].defaultMin || 0, CREATE_DATE_DEFAULT_WIDTH);

      newFields[key] = {
        ...newFields[key],
        minWidth,
        maxWidth,
        defaultMin
      };
    }
  });
  return newFields;
};
